// eslint-disable-next-line import/no-cycle
import Client from '../HttpClient';

const baseUrl = '/gateway/eagle-mgt/api/vs/panda/posIntegration';

const getPosData = (merchantId, branchId, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/${branchId}/pos_data`, payload);
};

const updatePosData = (merchantId, payload) => {
	return Client.post(`${baseUrl}/${merchantId}/pos_data`, payload);
};

const disconnect = (merchantId, payload) => {
	return Client.post(`${baseUrl}/${merchantId}/pos_data/remove`, payload);
};

const storeList = (merchantId, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/stores`, payload);
};

const shopStatus = (merchantId, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/pos_data/shop_status`, payload);
};

export default { getPosData, updatePosData, disconnect, storeList, shopStatus };
